// utils/lazyWithReload.js
import React from 'react';

const lazyWithReload = (importFunc: any) =>
  React.lazy(() =>
    importFunc().catch((error: any) => {
      const isChunkLoadError =
        error?.message?.includes('Failed to fetch dynamically imported module') ||
        error?.message?.includes('Loading chunk') ||
        error?.name === 'ChunkLoadError';

      if (isChunkLoadError) {
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.replace(`${baseUrl}?reload=${Date.now()}`);
      }

      throw error;
    })
  );

export default lazyWithReload;
